import { Column } from 'react-table';
import { Avatar, Box, styled, Tooltip, Typography } from '@mui/material';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { DayColumnAccessors } from '../../calendar/calendar-grid.types';
import { AvailabilityParsed } from '../availability-calendar.types';

export const getGridColDefs = (): Column<AvailabilityParsed<DayColumnAccessors>>[] => {
  const workerColumn: Column<AvailabilityParsed<DayColumnAccessors>> = {
    Header: () => <StyledHeaderCell variant="inherit">Werker</StyledHeaderCell>,
    accessor: 'worker',
    width: '200px',
    Cell: ({ value }: { value: AvailabilityParsed<DayColumnAccessors>['worker'] }) => (
      <StyledContainer>
        <Avatar src={value.profilePictureUrl} alt="Profile Picture" />
        <Tooltip title={getFullNameWithInfix(value)}>
          <StyledWorkerCell variant="inherit">{getFullNameWithInfix(value)}</StyledWorkerCell>
        </Tooltip>
      </StyledContainer>
    ),
  };

  return [workerColumn];
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(2),
}));

const StyledWorkerCell = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: theme.palette.lwBlack[100],
  padding: theme.spacing(5),
  fontWeight: 'bold',
  textAlign: 'right',
}));
const StyledHeaderCell = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: theme.palette.lwSecondary[40],
  padding: theme.spacing(5),
  fontWeight: 'bold',
  justifyContent: 'center',
  textAlign: 'center',
}));
